<template>
    <div v-if="config" class="w-full">
        <setting-card
            v-bind="binds"
            :hideMoreVert="true"
            :hidePrevious="hidePrevious"
            :hideValid="currentStep !== 'declaration_setting' ? true : false"
            @updateProfile="updateProfile()"
            @previous="actions.previous"
            @close="currentStep = 'declaration_setting'"
        >
            <v-window v-model="currentStep">
                <v-window-item value="declaration_setting" style="width: 50vw">
                    <v-row no-gutters class="d-flex justify-center">
                        <v-col cols="8" class="pb-2 pt-6 text-h6 pl-3">{{
                            $t("settingDeclaration.codes-ROF")
                        }}</v-col>
                        <v-col cols="8">
                            <v-row no-gutters class="rounded-xl px-2 border-thin">
                                <v-col
                                    cols="12"
                                    v-for="(item, index) in config.rofs"
                                    :key="index + 1"
                                >
                                    <v-divider v-if="index && index < config.rofs.length - 1" />
                                    <v-row no-gutters v-if="item.prefix !== 'ISGROUPE'">
                                        <v-col
                                            cols="7"
                                            class="d-flex align-center"
                                            :key="index + 2"
                                            style="height: 62px"
                                        >
                                            {{ translateTaxName(item.tax) }}
                                        </v-col>
                                        <v-col
                                            cols="5"
                                            class="d-flex justify-end align-center"
                                            :key="index + 3"
                                            style="height: 62px"
                                        >
                                            <v-text-field-filled
                                                v-model="item.code"
                                                hide-details
                                                outlined
                                                :prefix="item.prefix"
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters v-else-if="incomeCategory !== 'BNC'">
                                        <v-col
                                            cols="7"
                                            class="d-flex align-center"
                                            :key="index + 4"
                                            style="height: 62px"
                                        >
                                            {{ translateTaxName(item.tax) }}
                                            <v-spacer />
                                            <v-switch
                                                v-model="config.taxIntegration"
                                                hide-details
                                                class="mt-0 pt-0"
                                            />
                                            <v-spacer />
                                        </v-col>
                                        <v-col
                                            cols="5"
                                            class="d-flex justify-end align-center"
                                            :key="index + 5"
                                            style="height: 62px"
                                        >
                                            <v-text-field-filled
                                                v-if="config.taxIntegration"
                                                v-model="item.code"
                                                hide-details
                                                outlined
                                                :prefix="item.prefix"
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="8" class="pb-2 pt-6 text-h6 pl-3"> OGA </v-col>
                        <v-col cols="8">
                            <v-row no-gutters class="rounded-xl px-2 border-thin">
                                <v-col cols="6" class="d-flex align-center" style="height: 62px">
                                    {{ $t("settingDeclaration.adhesion-OGA") }};
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="d-flex justify-end align-center"
                                    style="height: 62px"
                                >
                                    <v-switch
                                        v-model="config.ogaEnrolment"
                                        hide-details
                                        class="mt-0 pt-0"
                                    />
                                </v-col>
                                <template v-if="config.ogaEnrolment">
                                    <v-col cols="12">
                                        <v-divider />
                                        <v-row no-gutters style="height: 62px">
                                            <v-col cols="6" class="d-flex align-center pr-1">
                                                <v-text-field-filled
                                                    v-model="config.ogaEnrolmentConfig.numberId"
                                                    hide-details
                                                    :label="
                                                        $t(
                                                            'settingDeclaration.numero-identification',
                                                        )
                                                    "
                                                    outlined
                                                    density="compact"
                                                />
                                            </v-col>
                                            <v-col cols="6" class="d-flex align-center pl-1">
                                                <v-text-field-filled
                                                    v-model="config.ogaEnrolmentConfig.year"
                                                    hide-details
                                                    :label="$t('settingDeclaration.annee')"
                                                    outlined
                                                    density="compact"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider />
                                        <v-text-field-filled
                                            v-model="config.ogaEnrolmentConfig.siret"
                                            hide-details
                                            :label="$t('settingDeclaration.SIRET')"
                                            outlined
                                            class="my-2"
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider />
                                        <v-text-field-filled
                                            v-model="config.ogaEnrolmentConfig.designation"
                                            hide-details
                                            :label="$t('settingDeclaration.designation')"
                                            outlined
                                            class="my-2"
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider />
                                        <v-text-field-filled
                                            v-model="config.ogaEnrolmentConfig.address"
                                            hide-details
                                            :label="$t('settingDeclaration.addresse')"
                                            outlined
                                            class="my-2"
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider />
                                        <v-row no-gutters style="height: 62px">
                                            <v-col cols="6" class="d-flex align-center pr-1">
                                                <v-text-field-filled
                                                    v-model="config.ogaEnrolmentConfig.postalCode"
                                                    hide-details
                                                    :label="$t('settingDeclaration.code-postal')"
                                                    outlined
                                                    density="compact"
                                                />
                                            </v-col>
                                            <v-col cols="6" class="d-flex align-center pl-1">
                                                <v-text-field-filled
                                                    v-model="config.ogaEnrolmentConfig.city"
                                                    hide-details
                                                    :label="$t('settingDeclaration.ville')"
                                                    outlined
                                                    density="compact"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-col>
                        <v-col cols="8" class="pb-2 pt-6 text-h6 pl-3">
                            {{ $t("settingDeclaration.paiement") }}
                            <v-btn-icon @click="dialogInfoVatBankAccount = true" icon="$oss-help" />
                        </v-col>
                        <v-col cols="8">
                            <v-row
                                no-gutters
                                class="rounded-xl border-thin px-2"
                                style="height: 62px"
                            >
                                <v-col class="d-flex align-center">
                                    {{ $t("settingDeclaration.compte-bancaire-telepay") }}
                                </v-col>
                                <v-col class="d-flex justify-end align-center">
                                    <v-select-filled
                                        v-model="config.vatBankAccount.id"
                                        :items="bankAccounts"
                                        :rules="bankAccountSelectHint"
                                        item-value="id"
                                        rounded
                                        outlined
                                        hide-details="auto"
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="8" class="pb-2 pt-6 text-h6 pl-3">
                            {{ $t("settingDeclaration.souscription-mail-EDI") }}
                        </v-col>
                        <v-col cols="8" class="pb-2">
                            <v-row
                                no-gutters
                                class="rounded-xl border-thin px-2"
                                style="height: 62px"
                            >
                                <v-col cols="6" class="d-flex align-center">
                                    {{ $t("settingDeclaration.souscription-mail-tva") }}
                                </v-col>
                                <v-col cols="6" class="d-flex justify-end align-center">
                                    <v-btn @click="currentStep = 'select_user_tva'">{{
                                        $t("settingDeclaration.modifier-les-inscrits")
                                    }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="8" class="pb-2">
                            <v-row
                                no-gutters
                                class="rounded-xl border-thin px-2"
                                style="height: 62px"
                            >
                                <v-col cols="6" class="d-flex align-center">
                                    {{ $t("settingDeclaration.souscription-mail-IS") }}
                                </v-col>
                                <v-col cols="6" class="d-flex justify-end align-center">
                                    <v-btn @click="currentStep = 'select_user_is'">{{
                                        $t("settingDeclaration.modifier-les-inscrits")
                                    }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="8" class="pb-2">
                            <v-row
                                no-gutters
                                class="rounded-xl border-thin px-2"
                                style="height: 62px"
                            >
                                <v-col cols="6" class="d-flex align-center">
                                    {{ $t("settingDeclaration.souscription-mail-CVAE") }}
                                </v-col>
                                <v-col cols="6" class="d-flex justify-end align-center">
                                    <v-btn @click="currentStep = 'select_user_cvae'">{{
                                        $t("settingDeclaration.modifier-les-inscrits")
                                    }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <oss-dialog
                        v-if="dialogInfoVatBankAccount"
                        v-model="dialogInfoVatBankAccount"
                        title="$t('settingDeclaration.information')"
                        @valid="dialogInfoVatBankAccount = false"
                        @close="dialogInfoVatBankAccount = false"
                        width="600px"
                    >
                        <div class="text-center">
                            <h4>
                                {{ $t("settingDeclaration.dialog-header") }}
                            </h4>
                        </div>
                    </oss-dialog>
                </v-window-item>
                <v-window-item value="select_user_tva" style="width: 45vw">
                    <SelectUserForUserSubscription
                        :companyId="companyId"
                        mailToSubscribe="EDI_TVA"
                        :isBack="true"
                        :actions="actions"
                        @previous="currentStep = 'declaration_setting'"
                    >
                    </SelectUserForUserSubscription>
                </v-window-item>
                <v-window-item value="select_user_liasse" style="width: 45vw">
                    <SelectUserForUserSubscription
                        :companyId="companyId"
                        mailToSubscribe="EDI_LIASSE"
                        :isBack="true"
                        :actions="actions"
                        @previous="currentStep = 'declaration_setting'"
                    >
                    </SelectUserForUserSubscription>
                </v-window-item>
                <v-window-item value="select_user_is" style="width: 45vw">
                    <SelectUserForUserSubscription
                        :companyId="companyId"
                        mailToSubscribe="EDI_IS"
                        :isBack="true"
                        :actions="actions"
                        @previous="currentStep = 'declaration_setting'"
                    >
                    </SelectUserForUserSubscription>
                </v-window-item>
                <v-window-item value="select_user_cvae" style="width: 45vw">
                    <SelectUserForUserSubscription
                        :companyId="companyId"
                        mailToSubscribe="EDI_CVAE"
                        :isBack="true"
                        :actions="actions"
                        @previous="currentStep = 'declaration_setting'"
                    >
                    </SelectUserForUserSubscription>
                </v-window-item>
            </v-window>
        </setting-card>
    </div>
</template>

<script lang="ts">
import settingCard from "../SettingCard.vue";
import SelectUserForUserSubscription from "@/views/user/SelectUserForUserSubscription.vue";

import BANK_ACCOUNTS from "../../../graphql/bank/BankAccounts.gql";

import { Apollo } from "@/decorators";
import { Component, Vue, Watch, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { DialogAction } from "@/services/dialogAction";

@Component({
    components: {
        settingCard,
        SelectUserForUserSubscription,
    },
    emits: ["autoDeclaVatDialog", "updateProfile"],
})
export class SettingDeclaration extends Vue {
    @Prop({}) config!: any;
    @Prop({}) companyId!: string;
    @Prop({}) tempoConfig!: any;
    @Prop({}) incomeCategory!: string;

    actions: DialogAction = new DialogAction();
    dialogInfoVatBankAccount: boolean = false;
    currentStep: string = "declaration_setting";

    get binds() {
        return {
            title: this.$t("settingDeclaration.teledeclaration"),
            partnerName: "bobbee",
            text: this.$t("settingDeclaration.teledeclaration-text"),
        };
    }

    get hidePrevious() {
        return this.currentStep !== "declaration_setting" ? false : true;
    }

    get bankAccountSelectHint() {
        return [
            () => {
                const bankAccount = this.bankAccounts.find(
                    (x) => x.id === this.config.vatBankAccount.id,
                );
                if (bankAccount) {
                    if (!bankAccount.iban) {
                        return this.$t("settingDeclaration.renseigner-IBAN");
                    }
                    if (!bankAccount.bic) {
                        return this.$t("settingDeclaration.renseigner-BIC");
                    }
                }
                return true;
            },
        ];
    }

    @Apollo({
        query: BANK_ACCOUNTS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
    })
    bankAccounts = [];

    translateTaxName(taxName: string) {
        switch (taxName) {
            case "TVA": {
                return "Taxe sur la Valeur Ajoutée";
            }
            case "IS": {
                return "Impôt sur les Sociétés";
            }
            case "CVAE": {
                return "Cotisation sur la Valeur Ajoutée des Entreprises";
            }
            case "RCM": {
                return "Revenus de Capitaux Mobiliers";
            }
            case "TPS": {
                return "Taxe sur les Salaires";
            }
            case "FPC": {
                return "Formation Professionnelle Continue";
            }
            case "TA": {
                return "Taxe d'Apprentissage";
            }
            case "ISGROUPE": {
                return "Intégration Fiscale";
            }
            case "Intégration fiscale": {
                return "Intégration fiscale";
            }
            default: {
                return taxName;
            }
        }
    }

    autoDeclaVatDialog() {
        this.$emit("autoDeclaVatDialog");
    }

    updateProfile() {
        this.$emit("updateProfile");
    }

    setToDefaultStep() {
        this.currentStep = "delcaration_setting";
    }

    @Watch("actions", { immediate: true })
    mounts() {
        this.actions.previous = this.setToDefaultStep;
    }
}

export default toNative(SettingDeclaration);
</script>
